var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProdOneTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prodOneTime",
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.697,
    height: 83.697,
    viewBox: "0 0 83.697 83.697",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2261",
    "data-name": "Path 2261",
    d: "M73.292,35.7a18.367,18.367,0,0,1-17.65-23.1H10.9A7.407,7.407,0,0,0,3.5,20V79.8a7.407,7.407,0,0,0,7.4,7.4H70.693a7.407,7.407,0,0,0,7.4-7.4V35.07A18.942,18.942,0,0,1,73.292,35.7ZM42.823,67.653c.149.321-5.413,5.558-5.668,5.9a2.2,2.2,0,1,1-3.113-3.113L35.481,69A19.146,19.146,0,1,1,33.646,30.8a2.2,2.2,0,1,1,0,4.405,14.714,14.714,0,0,0-14.7,14.7A14.936,14.936,0,0,0,35.481,64.6L34.042,63.16a2.207,2.207,0,1,1,3.113-3.128l5.2,5.213a2.193,2.193,0,0,1,.47,2.408ZM47.948,69a2.2,2.2,0,1,1,0-4.405,14.714,14.714,0,0,0,14.7-14.7A14.936,14.936,0,0,0,46.112,35.2l1.439,1.439a2.2,2.2,0,1,1-3.113,3.113l-5.2-5.2a2.212,2.212,0,0,1,0-3.113l5.2-5.2a2.2,2.2,0,1,1,3.113,3.113L46.112,30.8h1.835c25.344,1.068,25.342,37.14,0,38.207ZM73.292,3.5A13.928,13.928,0,0,0,59.4,17.405c.687,18.355,27.046,18.472,27.8,0A13.925,13.925,0,0,0,73.292,3.5Zm2.863,19.1a2.2,2.2,0,1,1-4.405,0V15.937a2.162,2.162,0,0,1-1.938-.984,2.2,2.2,0,0,1,.6-3.054l2.305-1.527a2.22,2.22,0,0,1,3.436,1.835Z",
    transform: "translate(-3.5 -3.5)",
    fill: "#3364b4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdOneTime);
export default __webpack_public_path__ + "static/media/prodOneTime.ba84546199ef00dc547b0fa5850f3964.svg";
export { ForwardRef as ReactComponent };